
import { leonMediaArray } from './leonMedia'
import { larryReviewerProfile } from './leonReviewers'
import { larryBio, leonBio } from './leonBios'
import { leonDatingProfileHinge, leonDatingProfileBumble, leonDatingProfileTinder } from './leonDatingProfiles'

export const leonUser = {
  _id: 'leonUserId',
  email: 'leon@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: false,
  reviewerProfilesToSelectFrom: [
    { ...larryReviewerProfile }
  ],
  media: [ ...leonMediaArray ],
  bio: { ...leonBio },
  datingProfiles: [
    { ...leonDatingProfileHinge },
    { ...leonDatingProfileBumble },
    { ...leonDatingProfileTinder }
  ],
  reviewerProfile: {},
}

export const larryUser = {
  _id: 'larryUserId',
  email: 'larry@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...larryBio },
  datingProfiles: [],
  reviewerProfile: { ...larryReviewerProfile },
}
